module.exports = __webpack_public_path__ + "static/media/scroll1.b8bf39d1.png";